import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const store = {
  namespaced: true,
  state: {
    chats: {},
    // chatDto
    currentChat: {},
    currentChatUsername: null,
    pageSize: 10
  },
  mutations,
  actions,
  getters
};

export default store;
